var chunkToChildrenMap = {
	"489": [
		581,
		361,
		639,
		271,
		163,
		531,
		125,
		609,
		389
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));